import React from 'react';
import { Plus } from 'lucide-react';
import './style.css';

const ProjectCostsHiringPro = ({ project }) => {

    const project_cost_labor = project.project_cost_labor;
    const project_cost_labor_formatted = project_cost_labor.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const project_cost_materials = project.project_cost_materials;
    const project_cost_materials_formatted = project_cost_materials.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });

    const project_cost_total = project_cost_labor + project_cost_materials;
    const project_cost_total_formatted = project_cost_total.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });

    return (
        <div className="professional-type-cost-container">
            <div className="professional-type-cost-container-header">
                <span>Est. Cost: {project_cost_total_formatted}</span>
            </div>
            <div className="professional-type-cost-container-breakdown">
                <span className="professional-type-cost-text">Labor: {project_cost_labor_formatted}</span>
                <div className="professional-type-cost-container-breakdown-divider">
                    <Plus />
                </div>
                <span className="professional-type-cost-text">Materials: {project_cost_materials_formatted}</span>
            </div>
        </div>
    )
};

export default ProjectCostsHiringPro;